var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7280_38786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 11.9653H10.9913C8.40867 14.548 6.84688 16.5419 5.2522 18.1366L12.0348 18.7478L22.5599 17.7044C23.4784 16.0077 24 14.0648 24 12C24 11.9884 23.9996 11.9769 23.9996 11.9653Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25223 6.22613H22.5215C20.4807 2.51513 16.5343 0 12 0C8.69511 0 5.70279 1.33645 3.53271 3.498L5.25223 6.22613Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77388 17.7044C4.6951 18.7831 4.2782 19.687 3.49768 20.4675C5.67057 22.6493 8.67737 24 12 24C16.5626 24 20.5303 21.4535 22.5598 17.7044H5.77388Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.47995C-1.17157 8.16623 -1.17157 15.7642 3.51471 20.4506C5.45126 18.514 7.31374 16.6515 12 11.9653L3.51471 3.47995Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16523 11.9653C3.16523 10.2169 4.39396 8.75635 6.03477 8.39803C5.78259 8.34296 5.52093 8.3131 5.25215 8.3131C3.23507 8.3131 1.59998 9.94819 1.59998 11.9653C1.59998 13.9823 3.23507 15.6174 5.25215 15.6174C5.52088 15.6174 5.78254 15.5876 6.03477 15.5325C4.39396 15.1741 3.16523 13.7136 3.16523 11.9653Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99452 8.83482L6.18882 9.43266H6.81741L6.30882 9.80218L6.50312 10.4L5.99452 10.0306L5.48593 10.4L5.68022 9.80218L5.17163 9.43266H5.80022L5.99452 8.83482Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99452 10.4L6.18882 10.9979H6.81741L6.30882 11.3674L6.50312 11.9653L5.99452 11.5958L5.48593 11.9653L5.68022 11.3674L5.17163 10.9979H5.80022L5.99452 10.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99452 11.9653L6.18882 12.5631H6.81741L6.30882 12.9326L6.50312 13.5305L5.99452 13.161L5.48593 13.5305L5.68022 12.9326L5.17163 12.5631H5.80022L5.99452 11.9653Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99452 13.5305L6.18882 14.1283H6.81741L6.30882 14.4978L6.50312 15.0957L5.99452 14.7262L5.48593 15.0957L5.68022 14.4978L5.17163 14.1283H5.80022L5.99452 13.5305Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7280_38786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.721e83a2836d03a25e3e052a933151d1.svg";
export { ForwardRef as ReactComponent };